const whiteListEnv = ['azureDEV', 'azureDEV2', 'DEV1', 'DEV2', 'local'];
export default !whiteListEnv.includes(process.env.TARGET_ENV);
